/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 임시 파일 업로드 (견적 ID 불필요, 24시간 자동 삭제, 최대 10개 20MB)
 */
export const storageControllerUploadTemporaryFilesBodyFilesMax = 10;

export const storageControllerUploadTemporaryFilesBody = zod
  .object({
    files: zod
      .array(zod.instanceof(File))
      .max(storageControllerUploadTemporaryFilesBodyFilesMax)
      .describe("업로드할 파일 (최대 10개, 각 파일 최대 20MB)"),
  })
  .strict();
